import { makeStyles } from '@material-ui/core'
import React from 'react'
import { useState } from 'react'
import { useMutation } from 'react-query'
import decodeJwt from 'jwt-decode'
import BuildOutlinedIcon from '@material-ui/icons/BuildOutlined'
import impersonateUser from '../../Apis/user/impersonateUser'
import queryClient from '../../queryClient'
import QueryKeys from '../../utils/constants/queryKeys'
import loadAccess from '../../utils/helpers/loadAccess'
import {
  removeLocalStorageValue,
  setLocalStorageValue,
} from '../../utils/helpers/localStorageHelperMethods'
import localStorageIds, {
  ORG_SCOPED_LOCAL_STORAGE_KEYS,
} from '../../utils/constants/localStorageIds'
import useGetLocalStorage from '../../hooks/useGetLocalStorage'
import impersonationFieldStyles from './impersonationField.styles'

const useStyles = makeStyles(impersonationFieldStyles)

const ImpersonationField = (props) => {
  const { sideBarOpen } = props
  const [impersonationValue, setImpersonationValue] = useState('')
  const localStorageValue = useGetLocalStorage()
  const { [localStorageIds.IS_SUPER_ADMIN]: isSuperAdminLocal } = localStorageValue || {}
  const { [localStorageIds.IMPERSONATION]: impersonation } = localStorageValue || {}
  const classes = useStyles()

  const impersonateUserMutation = useMutation((data) => impersonateUser(data), {
    onSuccess: async (res) => {
      const { data } = res
      const { isSuperAdmin } = decodeJwt(data?.accessToken)

      // Set localStorage values
      setLocalStorageValue([
        { id: localStorageIds.TOKEN, value: data?.accessToken },
        { id: localStorageIds.INVITATIONS_SNACK_OPEN, value: false },
        {
          id: localStorageIds.IS_SUPER_ADMIN,
          value: JSON.parse(isSuperAdmin?.toLowerCase()),
        },
        {
          id: localStorageIds.IMPERSONATION,
          value: data?.impersonationEnabled,
        },
      ])

      // Impersonation starts a new session without going through startSession,
      // so clear the impersonator's org-scoped selections here too — otherwise
      // they leak into the impersonated user's session as its selected org.
      removeLocalStorageValue([
        localStorageIds.USER_INITIAL_UNCONFIRMED_EMAIL,
        localStorageIds.ADDONS,
        localStorageIds.USER_ORG_ROLES,
        localStorageIds.ORG_PERMISSIONS,
        localStorageIds.COMPETITION_PERMISSIONS,
        ...ORG_SCOPED_LOCAL_STORAGE_KEYS,
      ])
      queryClient.removeQueries(QueryKeys.GET_ACCOUNT_ME)
      await loadAccess()

      window.location = window.location.pathname
    },
  })

  const onSubmit = (e) => {
    e.preventDefault()
    const email = impersonationValue.trim()
    if (email) impersonateUserMutation.mutate({ email })
  }

  if (impersonation) return null

  if (!isSuperAdminLocal || !sideBarOpen || typeof isSuperAdminLocal !== 'boolean') return null

  return (
    <form className={classes.panel} onSubmit={onSubmit}>
      <span className={classes.eyebrow}>
        <BuildOutlinedIcon className={classes.eyebrowIcon} />
        Super user
      </span>
      <label htmlFor='impersonate-email' className={classes.label}>
        Impersonate a user
      </label>
      <div className={classes.row}>
        <input
          id='impersonate-email'
          type='email'
          placeholder='Email'
          autoComplete='off'
          className={classes.input}
          value={impersonationValue}
          onChange={(e) => setImpersonationValue(e.target.value)}
        />
        <button type='submit' className={classes.go} disabled={impersonateUserMutation.isLoading}>
          Go
        </button>
      </div>
      {impersonateUserMutation.isError && (
        <span className={classes.error}>No user with that email.</span>
      )}
    </form>
  )
}

export default ImpersonationField
